export default Object.freeze({
  BANNER_LINK: 'LINK',
  ITEM_TAG: 'TAG',
});
